import Footer from "../layout/footer"
import React, { Component,Suspense } from "react";
import $ from "jquery";
import { saveItCareerForm } from "../service";
import "../css/style.css";
import refreshBtn from "../images/refresh.png";
const Header = React.lazy(() => import("../layout/header"))
const HeaderAdmin = React.lazy(() => import("../layout/header"))
class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      password: "",
      usernameForgot: "",
      errorMsg: "",
      // emailSuccess: "",
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.clickHere = this.clickHere.bind(this);
    this.forgetPassword = this.forgetPassword.bind(this);
    this.loginDisplay = this.loginDisplay.bind(this);
    this.generateCaptcha = this.generateCaptcha.bind(this);
  }
  generateCaptcha = () => {
    const values = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let captcha = "";
    for (let i = 0; i < 6; i++) {
      captcha += values.charAt(Math.floor(Math.random() * values.length));
    }
    this.setState({ captcha });
  }
  componentDidMount() {
    this.generateCaptcha()
    $(".inputError").hide();
    $(".signupDiv").hide();
  }
  handleInputChange = (event) => {
    const { value, name } = event.target;
    this.setState({
      [name]: value,
    });
  };
  loginDisplay = (e) => {
    $(".signupDiv").hide();
    $(".loginDiv").show();
    $("#errorMsg").hide();
  };
  forgetPassword = (e) => {
    e.preventDefault();
    var characters = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
    let email = this.state.email;
    if (email === "") {
        $("#errorMsg").show();
        this.setState({errorMsg : "Email required"})
        $("#email").focus();
      }
      else if(email.includes('@') && characters.test(email) === false) {
        this.setState({errorMsg : "Invalid Email Address"})
        $("#email").focus() 
      }
    else {
        const postData = {
          "functionName": "sendMail",
          "toMailId": $("#email").val()
        }
        saveItCareerForm(postData).then((data) => {
          console.log("forget...................",data)
            if (data.data.success === "1") {
              this.setState({errorMsg : "Password reset link has been sent to your registered Email Id"})
            } else if (data.data.errorMessage){
             
              this.setState({errorMsg : "Invalid Email"})
            }
        })
    }
  };
  clickHere = (e) => {
    $(".signupDiv").show();
    $(".loginDiv").hide();
    this.setState({errorMsg : ""})
  };
  clickHere2 = (e) => {
    $(".signupDiv").hide();
    $(".loginDiv").show();
    this.setState({errorMsg : ""})
  };





onSubmit = (e) => {
  e.preventDefault();
  let username = this.state.username;
  let password = this.state.password;
  let functionName = "login";
  if(username === '' ) {
    $("#errorMsg").show();
    this.setState({errorMsg : "Username required"})
    $("#username").focus();
  }else if(password === ""){
    $("#errorMsg").show();
    this.setState({errorMsg : "Password required"})
    $("#password").focus();
  }else if(this.state.captcha !== this.state.userInput)
  {
    this.setState({userInput : ""})
    $("#captcha").val("")
    this.setState({errorMsg : "Invalid Captcha"})
    $("#captcha").focus();
  }
  else{
   // $("#errorMsg").hide();

   let postData = {
    functionName: "login",
    username: username,
    password: password
  };
  saveItCareerForm(postData).then((data) => {
          console.log('getUserAuthentication-- ',data)
          if(data.data.success=="1") {
            $("#errorMsg").hide();
              localStorage.setItem('userId', data.data.result.userData[0].userId);
              localStorage.setItem('username', data.data.result.userData[0].username);
              localStorage.setItem('role', data.data.result.userData[0].roleName);
              
              if (data.data.result.userData[0].roleName == "Admin" || data.data.result.userData[0].roleName == "SuperAdmin") {
                localStorage.setItem('isLogedIn',"1")
                localStorage.setItem('isEditor',data.data.result.userData[0].isEditor)
                if (data.data.result.userData[0].roleName == "Admin") {
                  localStorage.setItem('userPages',JSON.stringify(data.data.result.userData[0].userPages))     
                }
                else{
                  localStorage.setItem('userPages',JSON.stringify([]))     
                }                            
                window.location.href = '/dashboard'
              }else {
                  window.location.href = '/cms-login'
                  localStorage.setItem('isLogedIn',"0")
              }
          }else {
            $("#errorMsg").show();
            this.setState({errorMsg : "Username Or Password Is InValid."})              
          }
      });
    }}
    
  render() {
    return (
      <div className="main_wrapper">
       	<Suspense fallback={<div></div>}>
						<HeaderAdmin />
        {/* <Header /> */}
        <div className="loginDiv">
          <div className="am_block text-center pb-2">
            <h2 className="text-center w-100 mb-2 login_head">Login</h2>
          </div>
      
          
          <div className="login_inner">
            <form>
              <div id="errorMsg" className="alert_div">
                {this.state.errorMsg}
              </div>
              <input
                type="text"
                className="form-control"
                id="username"
                name="username"
                placeholder="User Name"
                onChange={this.handleInputChange}
              />
              <label id="nameError" className="inputError">
                {/* Please enter username */}
              </label>
              <input
                type="password"
                className="form-control"
                id="password"
                name="password"
                placeholder="Password"
                onChange={this.handleInputChange}
              />
              <label id="passwordErorr" className="inputError">
                {/* Please enter password */}
              </label>
              <>
              <form>
        <div className="refreshDiv">
          <span className="refreshText">{this.state.captcha}</span>
          <span className="refreshTextBtn"> <button onClick={this.generateCaptcha} className="refreshBtnLogin">
          <img src={refreshBtn} alt="refreshBtn" />
        </button></span>
        </div>
        <input type="text" id="captcha" placeholder="Enter the captcha value"  className="form-control captchaInput"
        onChange={event => this.setState({ userInput: event.target.value })} />
      </form>
              </>
              <input
                type="submit"
                value="Login "
                className="form-control"
                onClick={this.onSubmit}
              />
              <label id="forgotPassword" className="forgotPassword">
                Forgot Password? &nbsp;
                <span onClick={this.clickHere} className="login_clickto">Click Here</span>
              </label>
              
            </form>
          </div>
        </div>
        <div className="signupDiv" style={{display: "none"}}>
          <div className="am_block text-center pb-2">
            <h2 className="text-center w-100 mb-2 login_head">Forgot Password</h2>
          </div>
          <div className="login_inner signup_inner">
            <form>
              <div id="errorMsg" className="alert_div">
                {this.state.errorMsg}
              </div>
              <input
                type="text"
                className="form-control"
                id="email"
                name="email"
                placeholder="Email"
                onChange={this.handleInputChange}
              />
              <div className="signupDiv" style={{display: "none"}}>
              <input
                type="submit"
                value="Submit "
                className="form-control"
                onClick={this.forgetPassword}
              />
               <label id="forgotPassword" className="forgotPassword">
                Back to &nbsp;
                
                <span onClick={this.clickHere2} className="login_clickto">Login </span>
              </label>
              
              </div>
              {/* <span className="form-control" onClick={this.forgetPassword}>
                Submit
              </span>
              <span className="form-control" onClick={this.loginDisplay}>
              Submit
              </span> */}
            </form>
          </div>
        </div>
        {/* <Footer /> */}
        </Suspense>
      </div>
    );
  }}
export default Login;
